/* eslint-disable complexity */
import {data} from './interface';
import {Loading, Loaded, NoResult, LoadError} from './status';
import {useEffect, useRef, useState} from 'react';
import {getDocSideSvgByType} from '@/utils/docType';

interface IProps {
    list: data[];
    onClickItem: (item: data, index: number) => void;
    loadMore: (page: number) => void;
    hasMore: boolean;
    error: boolean;
    word: string;
    renderEnd: (tim: number) => void;
    renderStart?: (tim: number) => void;
    loading: boolean;
    onReload: () => void;
}

/*
  继原来的列表，重新写了一个自己实现的滚动加载
  超级好用，心情又变好了
*/
export function SidebarSearchList(props: IProps) {
    const {
        list,
        onClickItem,
        loadMore,
        hasMore = true,
        error = false,
        renderEnd,
        loading,
        onReload,
        word,
    } = props;
    const isLoadData = useRef(false);
    const page = useRef(1);
    useEffect(() => {
        // 组件渲染结束执行
        renderEnd(Date.now());
        isLoadData.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list]);


    function handleClick(item: data, index: number) {
        onClickItem(item, index);
    }

    function getTitleString(title: string) {
        if (!title) {
            return '';
        }
        return title.replace((/<em>|<\/em>/g), '');
    }

    function getItem(itemStr: string) {
        if (!itemStr) {
            return '';
        }
        const rel = itemStr.replace(/<em>/g, '<span class="sidebar-search-list-mark">');
        return rel.replace(/<\/em>/g, '</span>');
    }

    function preventDefault(e: any) {
        e.preventDefault();
    }

    const handleWheel = (e: any) => {
        // 当有惯性的wheel时间发生时需要等到wheel事件停止再去更新数据
        const listBox = document.querySelector('.sidebar-search-list') as HTMLDivElement;
        const {height} = listBox.getBoundingClientRect();
        const scrollTop = listBox.scrollTop;
        const scrollHeight = listBox.scrollHeight;
        // 要阻止冒泡不然会影响上层的滚动
        e.stopPropagation();
        // 顶部往上滚
        if (
            (scrollTop <= 5 && e.deltaY < 0)
            || (height + scrollTop >= (scrollHeight - 5) && e.deltaY > 0)
        ) {
            preventDefault(e);
        }

        // 底部往下滚
        if (
            (height + scrollTop >= (scrollHeight - 5) && e.deltaY > 0)
            && hasMore && !error && !isLoadData.current && loadMore
        ) {
            loadMore(page.current + 1);
            page.current++;
            isLoadData.current = true;
            // 在这里加载数据
            preventDefault(e);
        }
    };

    useEffect(() => {
        const listBox = document.querySelector('.sidebar-search-list') as HTMLDivElement;
        listBox && listBox.addEventListener('wheel', handleWheel);
        return () => {
            listBox && listBox.removeEventListener('wheel', handleWheel);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [word, list, hasMore]);

    useEffect(() => {
        page.current = 1;
    }, [word]);

    return (
        <div
            className="sidebar-search-inner"
        >
            <div
                className="sidebar-search-list"
            >
                {
                    list.map((item: any, index: number) => {
                        const Icon = getDocSideSvgByType(+item.docType);
                        return (
                            <div
                                onClick={
                                    () => {
                                        handleClick(item, index);
                                    }
                                }
                                className="sidebar-search-list-item"
                                title={`${getTitleString(item.title)}`}
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${item.id}-${word}-${item.docGuid}-${index}`}
                            >
                                <div
                                    className="sidebar-search-list-item-icon"
                                >
                                    {Icon ? <Icon /> : null}
                                </div>
                                <div
                                    className="sidebar-search-list-item-con"
                                    /* bca-disable */
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: getItem(item.title),
                                    }}
                                />
                            </div>
                        );
                    })
                }
                {
                    loading
                        ? <Loading />
                        : null
                }
                {
                    list.length === 0 && !hasMore && !error && !loading
                        ? <NoResult />
                        : null
                }
                {
                    !hasMore && list.length > 30 && !error && !loading
                        ? <Loaded />
                        : null
                }
                {
                    error && !loading
                        ? <LoadError
                            onReload={
                                () => {
                                    loadMore(page.current);
                                    onReload && onReload();
                                }
                            }
                        />
                        : null
                }
            </div>
        </div>
    );
}
